<ng-container #mailTemplateComponentHost ></ng-container>


